//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Border from './_border'
import Edu from './_edu'
import Circles from './_circles'
import Stars from '@/common/tpl/value_analysis/_stars'
export default {
    props: {
        building_id: [String, Number],
        building_name: String,
        show_vr_panorama: Boolean,
        traffics: Object,
        educations: Object,
        lives: Object,
        environments: Object
    },
    components: {
        Stars,
        Circles,
        Border,
        Edu
    },
    computed: {
        formatScore () {
            return (value) => {
                let score = parseInt(value)
                if (score >= 5 && score < 7) {
                    return 4
                } else if (score >= 7 && score < 8) {
                    return 4.5
                } else if (score >= 8) {
                    return 5
                }
                return 3
            }                
        }
    },
    methods: {
        goAround (category = '') {
            wx.navigateTo({
                url: `/building/around_facilities/map/main?id=${this.building_id}&type=building&category=${category}`
            })
        },
        openWeb720 () {
            wx.navigateTo({
                url: `/building/web_720?building_id=${this.building_id}&title=${this.building_name || ''}`
            })
        },
    }
}
